import * as React from 'react';
import { Hr, Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const VehicleOwnershipRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    value.vehicles.map((vehicle, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement(Hr, null),
        React.createElement(Paragraph, { className: 'HeadingSpace', bold: true }, `${i18n('common.vehicle')} ${index + 1}`),
        React.createElement(TwoColRow, { label: i18n('common.registrationnumber'), value: vehicle.registrationNumber }),
        React.createElement(TwoColRow, { label: i18n('common.vehicletype'), value: i18n(`common.${vehicle.type.toLocaleLowerCase()}`) }),
        React.createElement(TwoColRow, { label: i18n('common.make'), value: vehicle.make }),
        React.createElement(TwoColRow, { label: i18n('common.vehicleyear'), value: vehicle.year })))),
    value.comment != '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default VehicleOwnershipRow;
